import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import authService from './authService';
import './css/LoginRegForm.css';
import logo from './images/logo1.png';

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [token, setToken] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tokenValidated, setTokenValidated] = useState(false);
    
    const navigate = useNavigate();
    const location = useLocation();

    // Extract token from URL parameters when component mounts
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tokenFromUrl = searchParams.get('token');
        
        if (tokenFromUrl) {
            setToken(tokenFromUrl);
            setTokenValidated(true);
        } else {
            setError(true);
            setMessage('Invalid or missing reset token. Please request a new password reset link.');
        }
    }, [location]);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Simple validation
        if (newPassword !== confirmPassword) {
            setError(true);
            setMessage('Passwords do not match.');
            return;
        }
        
        if (newPassword.length < 8) {
            setError(true);
            setMessage('Password must be at least 8 characters long.');
            return;
        }
        
        setLoading(true);
        setMessage('');
        setError(false);
        setSuccess(false);

        authService.confirmPasswordReset(token, newPassword, confirmPassword)
            .then(() => {
                setSuccess(true);
                setMessage('Your password has been reset successfully.');
                
                // Reset form
                setNewPassword('');
                setConfirmPassword('');
                
                // Redirect to login page after a delay
                setTimeout(() => {
                    navigate('/login', { 
                        state: { 
                            message: 'Your password has been reset successfully. You can now log in with your new password.',
                            messageType: 'success' 
                        }
                    });
                }, 3000);
            })
            .catch(error => {
                setError(true);
                setMessage(error.message || 'An error occurred while resetting your password.');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    if (!tokenValidated) {
        return (
            <div className='logreg-back'>
                <div className="box-con">
                    <div className="box">
                        <div className="upper-part">
                            <img className="logo" src={logo} alt="logo" />
                        </div>
                        <div className="message-group"
                            style={{ backgroundColor: 'rgb(221, 167, 164)' }}>
                            <div className="svg-div-first">
                                <svg style={{ color: 'rgb(213, 129, 161)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                                </svg>
                            </div>
                            <p className="message">{message}</p>
                        </div>
                        <div className='back-to-login'>
                            <Link to="/forgot-password" className="back-link">Request a new reset link</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='logreg-back'>
            <div className="box-con">
                <div className="box">
                    <div className="upper-part">
                        <img className="logo" src={logo} alt="logo" />
                    </div>
                    <div className="tab-container">
                        <Link
                            to="/login"
                            className="tab right-disp inactive-tab">
                            Log in
                        </Link>
                        <Link
                            to="/register"
                            className="tab right-disp inactive-tab">
                            Sign up
                        </Link>
                    </div>

                    <form className="form" onSubmit={handleSubmit}>
                        <div className='form-wrapper'>

                            
                            {message && (
                                <div className="message-group message-group-grow"
                                    style={{ backgroundColor: error ? 'rgb(221, 167, 164)' : success ? 'rgb(167, 221, 164)' : 'transparent' }}>
                                    <div className="svg-div-first">
                                        {error ? (
                                            <svg style={{ color: 'rgb(213, 129, 161)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                                            </svg>
                                        ) : success ? (
                                            <svg style={{ color: 'rgb(129, 213, 161)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                            </svg>
                                        ) : null}
                                    </div>
                                    <p className="message">{message}</p>
                                </div>
                            )}

                            <p className="reset-subtitle">
                                Enter your new password below.
                            </p>
                            <div className="form-group form-first">
                                <div className="svg-div">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-lock-fill" viewBox="0 0 16 16">
                                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
                                    </svg>
                                </div>
                                <div className="password-form">
                                    <input
                                        className='inp-col'
                                        type="password" 
                                        name="newPassword" 
                                        placeholder="New Password" 
                                        value={newPassword} 
                                        onChange={(e) => setNewPassword(e.target.value)} 
                                        required 
                                        minLength="8"
                                    />
                                </div>
                            </div>
                            <div className="form-group form-last confirm-form">
                                <div className="svg-div">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-lock-fill" viewBox="0 0 16 16">
                                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
                                    </svg>
                                </div>
                                <div className="password-form">
                                    <input
                                        className='inp-col'
                                        type="password" 
                                        name="confirmPassword" 
                                        placeholder="Confirm Password" 
                                        value={confirmPassword} 
                                        onChange={(e) => setConfirmPassword(e.target.value)} 
                                        required 
                                        minLength="8"
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='button-wrap'>
                                <button 
                                    className="login-but" 
                                    type="submit" 
                                    disabled={loading}
                                >
                                    {loading ? 'RESETTING...' : 'RESET PASSWORD'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>    
            </div>
        </div>
    );
};

export default ResetPassword;